allGame = [
  {
    gameId: 145,
    orType: 1,
    sort: 10,
    code: "wild_racing_3d",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Wild Racing 3D"
      },
      {
        lang: "ZH",
        values: "天天飙车"
      },
      {
        lang: "TR",
        values: "Tehlikeli Yarış"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/b618d5ddf98144ba9cd559b963005ee5.jpg",
    tags: [
      {
        code: "sport",
        name: [
          {
            lang: "zh",
            values: "体育"
          },
          {
            lang: "en",
            values: "Sport"
          },
          {
            lang: "ja",
            values: "スポーツ"
          }
        ]
      },
      {
        code: "merge",
        name: [
          {
            lang: "zh",
            values: "合成"
          },
          {
            lang: "en",
            values: "Merge"
          },
          {
            lang: "ja",
            values: "合成"
          }
        ]
      },
      {
        code: "racing",
        name: [
          {
            lang: "zh",
            values: "竞速"
          },
          {
            lang: "en",
            values: "Racing"
          },
          {
            lang: "ja",
            values: "レース"
          }
        ]
      },
      {
        code: "driving",
        name: [
          {
            lang: "zh",
            values: "驾驶"
          },
          {
            lang: "en",
            values: "Driving"
          },
          {
            lang: "ja",
            values: "ドライビング"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "car",
        name: [
          {
            lang: "zh",
            values: "赛车"
          },
          {
            lang: "en",
            values: "Car"
          },
          {
            lang: "ja",
            values: "カーレース"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/wild-racing-3d/index.html"
  },
  {
    gameId: 155,
    orType: 1,
    sort: 10,
    code: "run_and_gun",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Run and Gun"
      },
      {
        lang: "ZH",
        values: "我出枪贼快"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/d757d93ff4734516970dcbaeea6cc444.png",
    tags: [
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "strategy",
        name: [
          {
            lang: "zh",
            values: "策略"
          },
          {
            lang: "en",
            values: "Strategy"
          },
          {
            lang: "ja",
            values: "ストラテジー"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "io",
        name: [
          {
            lang: "zh",
            values: "对抗"
          },
          {
            lang: "en",
            values: "IO"
          },
          {
            lang: "ja",
            values: "対戦"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/run-and-gun/index.html"
  },
  {
    gameId: 147,
    orType: 1,
    sort: 10,
    code: "galaxy_avengers",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Galaxy Avengers"
      },
      {
        lang: "ZH",
        values: "飞机大战雷霆战机"
      },
      {
        lang: "TR",
        values: "Galaksi Savaşçıları"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/d073560efbdc411ca81d9bd5dee8c0af.png",
    tags: [
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "war",
        name: [
          {
            lang: "zh",
            values: "战争"
          },
          {
            lang: "en",
            values: "War"
          },
          {
            lang: "ja",
            values: "戦争"
          }
        ]
      },
      {
        code: "sci-fi",
        name: [
          {
            lang: "zh",
            values: "科幻"
          },
          {
            lang: "en",
            values: "Sci-Fi"
          },
          {
            lang: "ja",
            values: "サイエンスフィクション"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "airplane",
        name: [
          {
            lang: "zh",
            values: "飞机"
          },
          {
            lang: "en",
            values: "Airplane"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/galaxy-avengers/index.html"
  },
  {
    gameId: 154,
    orType: 1,
    sort: 10,
    code: "candy_legend",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Candy Legend"
      },
      {
        lang: "ZH",
        values: "连连消消"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/f578adc52b004379930a85713b5140a4.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "girls",
        name: [
          {
            lang: "zh",
            values: "女生"
          },
          {
            lang: "en",
            values: "Girls"
          },
          {
            lang: "ja",
            values: "女性向け"
          }
        ]
      },
      {
        code: "cute",
        name: [
          {
            lang: "zh",
            values: "可爱"
          },
          {
            lang: "en",
            values: "Cute"
          },
          {
            lang: "ja",
            values: "かわいい系"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/candy-legend/index.html"
  },
  {
    gameId: 156,
    orType: 1,
    sort: 10,
    code: "line_puzzle",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Line Puzzle"
      },
      {
        lang: "ZH",
        values: "线之迷惑"
      },
      {
        lang: "TR",
        values: "İpleri Çöz"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/6656cb2276874e69863c7b2ea5871b67.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "brain",
        name: [
          {
            lang: "zh",
            values: "脑力"
          },
          {
            lang: "en",
            values: "Brain"
          },
          {
            lang: "ja",
            values: "思考"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "hypercasual",
        name: [
          {
            lang: "zh",
            values: "超休闲"
          },
          {
            lang: "en",
            values: "Hypercasual"
          }
        ]
      },
      {
        code: "education",
        name: [
          {
            lang: "zh",
            values: "教育"
          },
          {
            lang: "en",
            values: "Education"
          },
          {
            lang: "ja",
            values: "教育"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "strategy",
        name: [
          {
            lang: "zh",
            values: "策略"
          },
          {
            lang: "en",
            values: "Strategy"
          },
          {
            lang: "ja",
            values: "ストラテジー"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/line-puzzle/index.html"
  },
  {
    gameId: 160,
    orType: 1,
    sort: 10,
    code: "blade_master",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Blade Master"
      },
      {
        lang: "TR",
        values: "Kılıç Ustası"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/7d0f58e5d42549e998e6c91ad7a26821.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "pve",
        name: [
          {
            lang: "zh",
            values: "PVE"
          },
          {
            lang: "en",
            values: "PVE"
          },
          {
            lang: "en",
            values: "PVE"
          }
        ]
      },
      {
        code: "magic",
        name: [
          {
            lang: "zh",
            values: "魔幻"
          },
          {
            lang: "en",
            values: "Magic"
          },
          {
            lang: "ja",
            values: "マジック"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "defense",
        name: [
          {
            lang: "zh",
            values: "防御"
          },
          {
            lang: "en",
            values: "Defense"
          },
          {
            lang: "ja",
            values: "ディフェンス"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/blade-master/index.html"
  },
  {
    gameId: 161,
    orType: 1,
    sort: 10,
    code: "merge_number_puzzle",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Merge Number Puzzle"
      },
      {
        lang: "ZH",
        values: "数字叠叠乐"
      },
      {
        lang: "TR",
        values: "Birleştir Kazan"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/c581714e971b47a28afe0a0aac3089a9.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "merge",
        name: [
          {
            lang: "zh",
            values: "合成"
          },
          {
            lang: "en",
            values: "Merge"
          },
          {
            lang: "ja",
            values: "合成"
          }
        ]
      },
      {
        code: "kid",
        name: [
          {
            lang: "zh",
            values: "儿童"
          },
          {
            lang: "en",
            values: "Kid"
          },
          {
            lang: "ja",
            values: "子供向け"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/merge-number-puzzle/index.html"
  },
  {
    gameId: 162,
    orType: 1,
    sort: 10,
    code: "rope_rescue",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Rope Rescue"
      },
      {
        lang: "ZH",
        values: "绳索拯救"
      },
      {
        lang: "TR",
        values: "Halatla Kurtarma"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/0dbe2c24d251400294dbb5db3e58efbe.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "pixel",
        name: [
          {
            lang: "zh",
            values: "像素"
          },
          {
            lang: "en",
            values: "Pixel"
          },
          {
            lang: "ja",
            values: "Pixel"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "brain",
        name: [
          {
            lang: "zh",
            values: "脑力"
          },
          {
            lang: "en",
            values: "Brain"
          },
          {
            lang: "ja",
            values: "思考"
          }
        ]
      },
      {
        code: "kid",
        name: [
          {
            lang: "zh",
            values: "儿童"
          },
          {
            lang: "en",
            values: "Kid"
          },
          {
            lang: "ja",
            values: "子供向け"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/rope-rescue/index.html"
  },
  {
    gameId: 164,
    orType: 1,
    sort: 10,
    code: "block_shooter",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Block Shooter"
      },
      {
        lang: "ZH",
        values: "方块收割者"
      },
      {
        lang: "TR",
        values: "Duvar Yıkıcı"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/8856422a6b004c07a6a0fe312159090a.png",
    tags: [
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "sci-fi",
        name: [
          {
            lang: "zh",
            values: "科幻"
          },
          {
            lang: "en",
            values: "Sci-Fi"
          },
          {
            lang: "ja",
            values: "サイエンスフィクション"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/block-shooter/index.html"
  },
  {
    gameId: 163,
    orType: 1,
    sort: 10,
    code: "moving_master",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Moving Master"
      },
      {
        lang: "ZH",
        values: "奔跑吧小仙女"
      },
      {
        lang: "TR",
        values: "Köprü Yarışı"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/28202b04f24a4835b8a21205cc8c1a49.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "girls",
        name: [
          {
            lang: "zh",
            values: "女生"
          },
          {
            lang: "en",
            values: "Girls"
          },
          {
            lang: "ja",
            values: "女性向け"
          }
        ]
      },
      {
        code: "cute",
        name: [
          {
            lang: "zh",
            values: "可爱"
          },
          {
            lang: "en",
            values: "Cute"
          },
          {
            lang: "ja",
            values: "かわいい系"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/move-master/index.html"
  },
  {
    gameId: 165,
    orType: 1,
    sort: 10,
    code: "kitty_runner",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Kitty Runner"
      },
      {
        lang: "ZH",
        values: "懒猫跑酷"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/b8960fc009984d4b9f62b017d1efeb92.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "parkour",
        name: [
          {
            lang: "zh",
            values: "跑酷"
          },
          {
            lang: "en",
            values: "Parkour"
          },
          {
            lang: "ja",
            values: "パルクール"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/kitty-runner/index.html"
  },
  {
    gameId: 168,
    orType: 1,
    sort: 10,
    code: "hex_monster",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Hex Monster"
      },
      {
        lang: "ZH",
        values: "消除怪兽"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/d21827cbb7724966a5d6262d583e2022.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "magic",
        name: [
          {
            lang: "zh",
            values: "魔幻"
          },
          {
            lang: "en",
            values: "Magic"
          },
          {
            lang: "ja",
            values: "マジック"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "brain",
        name: [
          {
            lang: "zh",
            values: "脑力"
          },
          {
            lang: "en",
            values: "Brain"
          },
          {
            lang: "ja",
            values: "思考"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/hex-monster/index.html"
  },
  {
    gameId: 166,
    orType: 1,
    sort: 10,
    code: "run_ball",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Run Ball"
      },
      {
        lang: "ZH",
        values: "奔跑球球"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/79840fab7d1c4acbba07227b2a9fcb87.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "hypercasual",
        name: [
          {
            lang: "zh",
            values: "超休闲"
          },
          {
            lang: "en",
            values: "Hypercasual"
          }
        ]
      },
      {
        code: "brain",
        name: [
          {
            lang: "zh",
            values: "脑力"
          },
          {
            lang: "en",
            values: "Brain"
          },
          {
            lang: "ja",
            values: "思考"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "education",
        name: [
          {
            lang: "zh",
            values: "教育"
          },
          {
            lang: "en",
            values: "Education"
          },
          {
            lang: "ja",
            values: "教育"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/run-ball/index.html"
  },
  {
    gameId: 167,
    orType: 1,
    sort: 10,
    code: "bridge_master",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Bridge Master"
      },
      {
        lang: "ZH",
        values: "搭桥高手"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/195c1715e2fc461f8d73a0d426c50896.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "pixel",
        name: [
          {
            lang: "zh",
            values: "像素"
          },
          {
            lang: "en",
            values: "Pixel"
          },
          {
            lang: "ja",
            values: "Pixel"
          }
        ]
      },
      {
        code: "girls",
        name: [
          {
            lang: "zh",
            values: "女生"
          },
          {
            lang: "en",
            values: "Girls"
          },
          {
            lang: "ja",
            values: "女性向け"
          }
        ]
      },
      {
        code: "cute",
        name: [
          {
            lang: "zh",
            values: "可爱"
          },
          {
            lang: "en",
            values: "Cute"
          },
          {
            lang: "ja",
            values: "かわいい系"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl: "https://cdn.just4fun.sg/games/bridge-master/index.html"
  },
  {
    gameId: 149,
    orType: 1,
    sort: 5,
    code: "dangerous_road",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Dangerous Road"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/26d84ca5aae0447eaf392d0d101cc406.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "racing",
        name: [
          {
            lang: "zh",
            values: "竞速"
          },
          {
            lang: "en",
            values: "Racing"
          },
          {
            lang: "ja",
            values: "レース"
          }
        ]
      },
      {
        code: "parkour",
        name: [
          {
            lang: "zh",
            values: "跑酷"
          },
          {
            lang: "en",
            values: "Parkour"
          },
          {
            lang: "ja",
            values: "パルクール"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "car",
        name: [
          {
            lang: "zh",
            values: "赛车"
          },
          {
            lang: "en",
            values: "Car"
          },
          {
            lang: "ja",
            values: "カーレース"
          }
        ]
      },
      {
        code: "driving",
        name: [
          {
            lang: "zh",
            values: "驾驶"
          },
          {
            lang: "en",
            values: "Driving"
          },
          {
            lang: "ja",
            values: "ドライビング"
          }
        ]
      },
      {
        code: "adventure",
        name: [
          {
            lang: "zh",
            values: "冒险"
          },
          {
            lang: "en",
            values: "Adventure"
          },
          {
            lang: "ja",
            values: "アドベンチャー"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/3d4f4bb61726431f89b2adda9fcd3be6/index.html"
  },
  {
    gameId: 146,
    orType: 1,
    sort: 8,
    code: "parkour_climb",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Parkour Climb"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/c62ab5b133dc4614bbf45966168e086b.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "parkour",
        name: [
          {
            lang: "zh",
            values: "跑酷"
          },
          {
            lang: "en",
            values: "Parkour"
          },
          {
            lang: "ja",
            values: "パルクール"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "adventure",
        name: [
          {
            lang: "zh",
            values: "冒险"
          },
          {
            lang: "en",
            values: "Adventure"
          },
          {
            lang: "ja",
            values: "アドベンチャー"
          }
        ]
      },
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/f49d6f3ed59e403193086fb587d8d2af/index.html"
  },
  {
    gameId: 157,
    orType: 1,
    sort: 6,
    code: "bubble_invasion",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Bubble Invasion"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/b01b6e9d7e764af4913e757c20d55c2e.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "cute",
        name: [
          {
            lang: "zh",
            values: "可爱"
          },
          {
            lang: "en",
            values: "Cute"
          },
          {
            lang: "ja",
            values: "かわいい系"
          }
        ]
      },
      {
        code: "brain",
        name: [
          {
            lang: "zh",
            values: "脑力"
          },
          {
            lang: "en",
            values: "Brain"
          },
          {
            lang: "ja",
            values: "思考"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/8eb48b344b1b4d44b565faa7faf7ce7e/index.html"
  },
  {
    gameId: 153,
    orType: 0,
    sort: 6,
    code: "backgammon",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Backgammon"
      },
      {
        lang: "TR",
        values: "Tavla"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/30ccf8474afd4359a82f97e7fc504ce2.png",
    tags: [
      {
        code: "strategy",
        name: [
          {
            lang: "zh",
            values: "策略"
          },
          {
            lang: "en",
            values: "Strategy"
          },
          {
            lang: "ja",
            values: "ストラテジー"
          }
        ]
      },
      {
        code: "board",
        name: [
          {
            lang: "zh",
            values: "棋牌"
          },
          {
            lang: "en",
            values: "Board"
          },
          {
            lang: "ja",
            values: "ボード"
          }
        ]
      },
      {
        code: "brain",
        name: [
          {
            lang: "zh",
            values: "脑力"
          },
          {
            lang: "en",
            values: "Brain"
          },
          {
            lang: "ja",
            values: "思考"
          }
        ]
      },
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/dfc966cd74724e1c83c6875064555ba2/index.html"
  },
  {
    gameId: 148,
    orType: 1,
    sort: 6,
    code: "curvy_road",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Curvy Road"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/45d6c5d33e5d4de189d11fc71c95630b.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "racing",
        name: [
          {
            lang: "zh",
            values: "竞速"
          },
          {
            lang: "en",
            values: "Racing"
          },
          {
            lang: "ja",
            values: "レース"
          }
        ]
      },
      {
        code: "parkour",
        name: [
          {
            lang: "zh",
            values: "跑酷"
          },
          {
            lang: "en",
            values: "Parkour"
          },
          {
            lang: "ja",
            values: "パルクール"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "car",
        name: [
          {
            lang: "zh",
            values: "赛车"
          },
          {
            lang: "en",
            values: "Car"
          },
          {
            lang: "ja",
            values: "カーレース"
          }
        ]
      },
      {
        code: "driving",
        name: [
          {
            lang: "zh",
            values: "驾驶"
          },
          {
            lang: "en",
            values: "Driving"
          },
          {
            lang: "ja",
            values: "ドライビング"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/20626f548a144ec8a4fca14d5d8333eb/index.html"
  },
  {
    gameId: 159,
    orType: 1,
    sort: 5,
    code: "castle_fight_with_buddies",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Castle Fight With Buddies"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/9df1af99ed864b459e50f485d657a871.png",
    tags: [
      {
        code: "strategy",
        name: [
          {
            lang: "zh",
            values: "策略"
          },
          {
            lang: "en",
            values: "Strategy"
          },
          {
            lang: "ja",
            values: "ストラテジー"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "war",
        name: [
          {
            lang: "zh",
            values: "战争"
          },
          {
            lang: "en",
            values: "War"
          },
          {
            lang: "ja",
            values: "戦争"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "defense",
        name: [
          {
            lang: "zh",
            values: "防御"
          },
          {
            lang: "en",
            values: "Defense"
          },
          {
            lang: "ja",
            values: "ディフェンス"
          }
        ]
      },
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/d1c61967d6b146b09565eb628df6db49/index.html"
  },
  {
    gameId: 158,
    orType: 1,
    sort: 6,
    code: "chroma_challenge",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Chroma Challenge"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/721827e4207e4b4799dabc32ec954325.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/ad50a496fbb04021b06f5b49a12c67f4/index.html"
  },
  {
    gameId: 152,
    orType: 0,
    sort: 6,
    code: "ludo_hero",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Ludo Hero"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/e300966f579c4dd48ad32569f826638f.png",
    tags: [
      {
        code: "board",
        name: [
          {
            lang: "zh",
            values: "棋牌"
          },
          {
            lang: "en",
            values: "Board"
          },
          {
            lang: "ja",
            values: "ボード"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/9d557728d50f48f88a81db1613f8a63b/index.html"
  },
  {
    gameId: 151,
    orType: 1,
    sort: 0,
    code: "parkour_swing",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Parkour Swing"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/959cfd0cf93f47caa60e6a9b917a84e4.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/0d8fee46c6844b949867c8929a88a1ee/index.html"
  },
  {
    gameId: 150,
    orType: 1,
    sort: 9,
    code: "fruit_slice_frenzy",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Fruit Slice Frenzy"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/03cf1e1a40af44a899ea0c1b7a43ceaf.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "cute",
        name: [
          {
            lang: "zh",
            values: "可爱"
          },
          {
            lang: "en",
            values: "Cute"
          },
          {
            lang: "ja",
            values: "かわいい系"
          }
        ]
      },
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/6f58db96439a49b885ae818a9d0370fc/index.html"
  },
  {
    gameId: 170,
    orType: 1,
    sort: 0,
    code: "bird_bump",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Bird Bump"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/95b20d17a4704ff8888d5fcdd23e739e.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/888830a7be1744279f7d825c7cdfd17f/index.html"
  },
  {
    gameId: 174,
    orType: 1,
    sort: 0,
    code: "risky_train_crossing",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Risky Train Crossing"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/12c25f94396c4e7d89ff145c213cbf6f.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/54b36fa3632e482199f1d77f0edf1e94/index.html"
  },
  {
    gameId: 172,
    orType: 1,
    sort: 0,
    code: "cool_archer",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Cool Archer"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/1c5b2e7c0dc74b97b4c08373aa40c9b1.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/5e86f6fa41414381aad19983bb2d7ed9/index.html"
  },
  {
    gameId: 171,
    orType: 1,
    sort: 0,
    code: "parkour_rooftop",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Parkour Rooftop"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/19cf1e075138423586ca0dd0184fd7f0.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/d2f2b5f432c74f8389aaaa3b893c96b6/index.html"
  },
  {
    gameId: 175,
    orType: 1,
    sort: 0,
    code: "zombies_are_coming",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Zombies Are Coming"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/1dc47044b8064b3d9cba305beea76f7c.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/69f0e1c1ca7c4d58b6651d234cecfba5/index.html"
  },
  {
    gameId: 173,
    orType: 1,
    sort: 0,
    code: "stickman_swing",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Stickman Swing"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/7e11bda6b24c4380a510c1c0dd6cd581.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/4e92d94e30d74f3f8f05b212a9ac08b3/index.html"
  },
  {
    gameId: 169,
    orType: 1,
    sort: 0,
    code: "clash_of_warlord_orcs",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Clash of Warlord Orcs"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/2c0f91c055184a06bea3daf3271a1c7c.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/925f5f4ea73141939d83c3b6e9d90d03/index.html"
  },
  {
    gameId: 181,
    orType: 1,
    sort: 0,
    code: "santa_parkour",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Santa Parkour"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/b2b727ca1862416eab708d2e20f31d78.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/0dab5576c79f42d4a1aacf5c45cccc01/index.html"
  },
  {
    gameId: 129,
    orType: 1,
    sort: 1,
    code: "cool_goal",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Cool Goal"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/8b0bb53ad33b412e852fd23b9cd4e7df.png",
    tags: [
      {
        code: "sport",
        name: [
          {
            lang: "zh",
            values: "体育"
          },
          {
            lang: "en",
            values: "Sport"
          },
          {
            lang: "ja",
            values: "スポーツ"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "education",
        name: [
          {
            lang: "zh",
            values: "教育"
          },
          {
            lang: "en",
            values: "Education"
          },
          {
            lang: "ja",
            values: "教育"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/8cbfcc88bcfc4d74989248673114ab72/index.html"
  },
  {
    gameId: 91,
    orType: 1,
    sort: 1,
    code: "fruitskiller",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "FruitsKiller"
      },
      {
        lang: "ZH",
        values: "水果杀手"
      },
      {
        lang: "TR",
        values: "MeyveDoğrayıcısı"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/e1b722be47f549c3bb926780af2dad5a.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/bf95fb37a9734c4a9a78edbbe85299bc/index.html"
  },
  {
    gameId: 128,
    orType: 1,
    sort: 3,
    code: "chicken_in_air_combat",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Chicken in air combat"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/a8441f013ace404b8256f81048e413d2.png",
    tags: [
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "war",
        name: [
          {
            lang: "zh",
            values: "战争"
          },
          {
            lang: "en",
            values: "War"
          },
          {
            lang: "ja",
            values: "戦争"
          }
        ]
      },
      {
        code: "modern_warfare",
        name: [
          {
            lang: "zh",
            values: "现代战争"
          },
          {
            lang: "en",
            values: "Modern Warfare"
          },
          {
            lang: "ja",
            values: "モダン・ウォーフェア"
          }
        ]
      },
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "pixel",
        name: [
          {
            lang: "zh",
            values: "像素"
          },
          {
            lang: "en",
            values: "Pixel"
          },
          {
            lang: "ja",
            values: "Pixel"
          }
        ]
      },
      {
        code: "airplane",
        name: [
          {
            lang: "zh",
            values: "飞机"
          },
          {
            lang: "en",
            values: "Airplane"
          }
        ]
      },
      {
        code: "simulation",
        name: [
          {
            lang: "zh",
            values: "模拟"
          },
          {
            lang: "en",
            values: "Simulation"
          },
          {
            lang: "ja",
            values: "シミュレーション"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/e417362ef1a14d31987c9b3c0fa7f006/index.html"
  },
  {
    gameId: 124,
    orType: 1,
    sort: 4,
    code: "archer_warrior",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Archer Warrior"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/ad63c186f5384b43a1699d93eeac4c33.png",
    tags: [
      {
        code: "sport",
        name: [
          {
            lang: "zh",
            values: "体育"
          },
          {
            lang: "en",
            values: "Sport"
          },
          {
            lang: "ja",
            values: "スポーツ"
          }
        ]
      },
      {
        code: "fps",
        name: [
          {
            lang: "zh",
            values: "第一人称射"
          },
          {
            lang: "en",
            values: "FPS"
          },
          {
            lang: "ja",
            values: "FPS"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/ffeb9feec8424dd09f9c2469f794819a/index.html"
  },
  {
    gameId: 96,
    orType: 1,
    sort: 4,
    code: "traffic_go",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Traffic Go"
      },
      {
        lang: "TR",
        values: "Şehir Trafiği"
      },
      {
        lang: "ZH",
        values: "狂野都市飞车"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/bef0e84275744b92b0cc01ee7a7817f0.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "driving",
        name: [
          {
            lang: "zh",
            values: "驾驶"
          },
          {
            lang: "en",
            values: "Driving"
          },
          {
            lang: "ja",
            values: "ドライビング"
          }
        ]
      },
      {
        code: "car",
        name: [
          {
            lang: "zh",
            values: "赛车"
          },
          {
            lang: "en",
            values: "Car"
          },
          {
            lang: "ja",
            values: "カーレース"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/491fb7d75047401c9b05d21596937a3e/index.html"
  },
  {
    gameId: 94,
    orType: 1,
    sort: 0,
    code: "knife_shooter",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Knife Shooter"
      },
      {
        lang: "TR",
        values: "Keskin Bıçak"
      },
      {
        lang: "ZH",
        values: "贼6飞刀手"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/f2a6b0a509c849d3844e60b52dbcdf73.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/1c6d885e309b4fa48024e8e83b2efe6d/index.html"
  },
  {
    gameId: 99,
    orType: 1,
    sort: 4,
    code: "ninja_painter",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Ninja Painter"
      },
      {
        lang: "ZH",
        values: "小小忍者大画家"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/149eb6aa16c34332b23b8184d617eca0.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "magic",
        name: [
          {
            lang: "zh",
            values: "魔幻"
          },
          {
            lang: "en",
            values: "Magic"
          },
          {
            lang: "ja",
            values: "マジック"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "brain",
        name: [
          {
            lang: "zh",
            values: "脑力"
          },
          {
            lang: "en",
            values: "Brain"
          },
          {
            lang: "ja",
            values: "思考"
          }
        ]
      },
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "maze",
        name: [
          {
            lang: "zh",
            values: "迷宫"
          },
          {
            lang: "en",
            values: "Maze"
          },
          {
            lang: "ja",
            values: "迷宮"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/bb0004869d6d4101ba01f84b34aaae5c/index.html"
  },
  {
    gameId: 95,
    orType: 1,
    sort: 1,
    code: "synthetic_watermelon",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Synthetic Watermelon"
      },
      {
        lang: "TR",
        values: "Meyve Sepeti"
      },
      {
        lang: "ZH",
        values: "合成大西瓜"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/bec580ee6e1f4a34a454332df71ae480.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "cute",
        name: [
          {
            lang: "zh",
            values: "可爱"
          },
          {
            lang: "en",
            values: "Cute"
          },
          {
            lang: "ja",
            values: "かわいい系"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "merge",
        name: [
          {
            lang: "zh",
            values: "合成"
          },
          {
            lang: "en",
            values: "Merge"
          },
          {
            lang: "ja",
            values: "合成"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/3d582223cf3243928758f3b789a88ef6/index.html"
  },
  {
    gameId: 100,
    orType: 1,
    sort: 0,
    code: "bounzy",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Bounzy"
      },
      {
        lang: "ZH",
        values: "元素魔法师"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/3465fbae0e934d9da012ca792b056a05.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/0b839e4434334e93b626c05e2a45a3bb/index.html"
  },
  {
    gameId: 131,
    orType: 1,
    sort: 4,
    code: "cube_surfer",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Cube Surfer"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/0c86aa6a021c45868a528773eaa85268.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "pixel",
        name: [
          {
            lang: "zh",
            values: "像素"
          },
          {
            lang: "en",
            values: "Pixel"
          },
          {
            lang: "ja",
            values: "Pixel"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "parkour",
        name: [
          {
            lang: "zh",
            values: "跑酷"
          },
          {
            lang: "en",
            values: "Parkour"
          },
          {
            lang: "ja",
            values: "パルクール"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/60599f0e76124bc4bd760ca6daf8d9cb/index.html"
  },
  {
    gameId: 132,
    orType: 1,
    sort: 4,
    code: "fruit_link",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Fruit Link"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/f10f383c4f324b0db0fd697e90f5b2c6.png",
    tags: [
      {
        code: "puzzle",
        name: [
          {
            lang: "zh",
            values: "益智"
          },
          {
            lang: "en",
            values: "Puzzle"
          },
          {
            lang: "ja",
            values: "パズル"
          }
        ]
      },
      {
        code: "girls",
        name: [
          {
            lang: "zh",
            values: "女生"
          },
          {
            lang: "en",
            values: "Girls"
          },
          {
            lang: "ja",
            values: "女性向け"
          }
        ]
      },
      {
        code: "cute",
        name: [
          {
            lang: "zh",
            values: "可爱"
          },
          {
            lang: "en",
            values: "Cute"
          },
          {
            lang: "ja",
            values: "かわいい系"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/976e809220e0476288556de1cfce2e76/index.html"
  },
  {
    gameId: 133,
    orType: 1,
    sort: 2,
    code: "crack_shot",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Crack Shot"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/fa9784c9bf0e47149634a63db4fad4d8.png",
    tags: [
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "merge",
        name: [
          {
            lang: "zh",
            values: "合成"
          },
          {
            lang: "en",
            values: "Merge"
          },
          {
            lang: "ja",
            values: "合成"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/6459cd834805424baf52756d747f7b2a/index.html"
  },
  {
    gameId: 97,
    orType: 1,
    sort: 1,
    code: "archery",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Archery"
      },
      {
        lang: "ZH",
        values: "弓箭手"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/e5bd48ea12b34a60907ab3b0373ff148.png",
    tags: [
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "sport",
        name: [
          {
            lang: "zh",
            values: "体育"
          },
          {
            lang: "en",
            values: "Sport"
          },
          {
            lang: "ja",
            values: "スポーツ"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "pixel",
        name: [
          {
            lang: "zh",
            values: "像素"
          },
          {
            lang: "en",
            values: "Pixel"
          },
          {
            lang: "ja",
            values: "Pixel"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/fa5fc0ce32a24d478dadd9c81d173e36/index.html"
  },
  {
    gameId: 89,
    orType: 1,
    sort: 3,
    code: "battleships",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "BATTLESHIPS"
      },
      {
        lang: "ZH",
        values: "舰艇战争"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/c5374944651a4e79bfed9bef75706c04.png",
    tags: [
      {
        code: "war",
        name: [
          {
            lang: "zh",
            values: "战争"
          },
          {
            lang: "en",
            values: "War"
          },
          {
            lang: "ja",
            values: "戦争"
          }
        ]
      },
      {
        code: "modern_warfare",
        name: [
          {
            lang: "zh",
            values: "现代战争"
          },
          {
            lang: "en",
            values: "Modern Warfare"
          },
          {
            lang: "ja",
            values: "モダン・ウォーフェア"
          }
        ]
      },
      {
        code: "strategy",
        name: [
          {
            lang: "zh",
            values: "策略"
          },
          {
            lang: "en",
            values: "Strategy"
          },
          {
            lang: "ja",
            values: "ストラテジー"
          }
        ]
      },
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/72a1e4c867fa43e5ba2fef72c6c91ed3/index.html"
  },
  {
    gameId: 98,
    orType: 1,
    sort: 0,
    code: "city_link",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "City Link"
      },
      {
        lang: "ZH",
        values: "城市连接"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/b6b461515b4f4cabbeb7d3097dde1836.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/a7e5a15b5886464a9452a18b455bca29/index.html"
  },
  {
    gameId: 126,
    orType: 1,
    sort: 2,
    code: "royal_artillery",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Royal Artillery"
      },
      {
        lang: "TR",
        values: "Kraliyet Topçuları"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/d6bb82bab36e4ce6a365897b1e7f871a.png",
    tags: [
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "magic",
        name: [
          {
            lang: "zh",
            values: "魔幻"
          },
          {
            lang: "en",
            values: "Magic"
          },
          {
            lang: "ja",
            values: "マジック"
          }
        ]
      },
      {
        code: "merge",
        name: [
          {
            lang: "zh",
            values: "合成"
          },
          {
            lang: "en",
            values: "Merge"
          },
          {
            lang: "ja",
            values: "合成"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/7c3dbf6c82b747fa9c743d8616979126/index.html"
  },
  {
    gameId: 127,
    orType: 1,
    sort: 0,
    code: "charge_now_",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Charge Now "
      },
      {
        lang: "TR",
        values: "Şarjını Fulle"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/c502c13f038743d8b571903efc01854c.png",
    tags: [],
    playUrl:
      "https://cdn.just4fun.sg/games/9ace4c72faa748eab572771c6ec9cc5f/index.html"
  },
  {
    gameId: 125,
    orType: 1,
    sort: 2,
    code: "bike_rush",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Bike Rush"
      },
      {
        lang: "TR",
        values: "Bisiklet Yolu"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/48d67e7586394b8a969eeed373697e4e.png",
    tags: [
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "sport",
        name: [
          {
            lang: "zh",
            values: "体育"
          },
          {
            lang: "en",
            values: "Sport"
          },
          {
            lang: "ja",
            values: "スポーツ"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/82402a9b737b4709b01eeaeada2c160b/index.html"
  },
  {
    gameId: 130,
    orType: 0,
    sort: 2,
    code: "evolutionio",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Evolutionio"
      },
      {
        lang: "TR",
        values: "Savaşçı Balıklar"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/c025d54852364467987972d4a2ea39b9.png",
    tags: [
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "magic",
        name: [
          {
            lang: "zh",
            values: "魔幻"
          },
          {
            lang: "en",
            values: "Magic"
          },
          {
            lang: "ja",
            values: "マジック"
          }
        ]
      },
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "fighting",
        name: [
          {
            lang: "zh",
            values: "格斗"
          },
          {
            lang: "en",
            values: "Fighting"
          },
          {
            lang: "ja",
            values: "格闘"
          }
        ]
      },
      {
        code: "io",
        name: [
          {
            lang: "zh",
            values: "对抗"
          },
          {
            lang: "en",
            values: "IO"
          },
          {
            lang: "ja",
            values: "対戦"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "trending",
        name: [
          {
            lang: "zh",
            values: "热门"
          },
          {
            lang: "en",
            values: "Trending"
          },
          {
            lang: "ja",
            values: "人気"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/6bdbde36f74f41c4a67513cfa26146c1/index.html"
  },
  {
    gameId: 103,
    orType: 1,
    sort: 1,
    code: "basketball_master",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Basketball Master"
      },
      {
        lang: "ZH",
        values: "篮球高高手"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/71bfe5f3b0cf46b3abc994a956cafba0.png",
    tags: [
      {
        code: "sport",
        name: [
          {
            lang: "zh",
            values: "体育"
          },
          {
            lang: "en",
            values: "Sport"
          },
          {
            lang: "ja",
            values: "スポーツ"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/d84d6c170b2d43509a5325fbfa20a89a/index.html"
  },
  {
    gameId: 101,
    orType: 1,
    sort: 3,
    code: "shooting_cubes",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Shooting Cubes"
      },
      {
        lang: "ZH",
        values: "打方块"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/106c398c8f374bbba54309ff3ebf7756.png",
    tags: [
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "merge",
        name: [
          {
            lang: "zh",
            values: "合成"
          },
          {
            lang: "en",
            values: "Merge"
          },
          {
            lang: "ja",
            values: "合成"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/982c7129eb9345dba6b70d9951852665/index.html"
  },
  {
    gameId: 134,
    orType: 1,
    sort: 1,
    code: "beefighter-biubuibiu",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "BeeFighter-Biubuibiu~"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/3e866b38101a4a0295041bfc4bab6b39.png",
    tags: [
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "sci-fi",
        name: [
          {
            lang: "zh",
            values: "科幻"
          },
          {
            lang: "en",
            values: "Sci-Fi"
          },
          {
            lang: "ja",
            values: "サイエンスフィクション"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "airplane",
        name: [
          {
            lang: "zh",
            values: "飞机"
          },
          {
            lang: "en",
            values: "Airplane"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/3eacd5e63e8f4b1a92fe1a92f1d6e6ca/web/index.html"
  },
  {
    gameId: 104,
    orType: 1,
    sort: 1,
    code: "cute_mining",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Cute Mining"
      },
      {
        lang: "ZH",
        values: "呆萌采矿"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/301d1e2572374072acdb935897574ee0.png",
    tags: [
      {
        code: "simulation",
        name: [
          {
            lang: "zh",
            values: "模拟"
          },
          {
            lang: "en",
            values: "Simulation"
          },
          {
            lang: "ja",
            values: "シミュレーション"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "management",
        name: [
          {
            lang: "zh",
            values: "管理"
          },
          {
            lang: "en",
            values: "Management"
          },
          {
            lang: "ja",
            values: "マネジメント"
          }
        ]
      },
      {
        code: "idle",
        name: [
          {
            lang: "zh",
            values: "挂机"
          },
          {
            lang: "en",
            values: "Idle"
          },
          {
            lang: "ja",
            values: "放置系"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/40c5cd56a84042c1b1b0c0f06a11878d/index.html"
  },
  {
    gameId: 102,
    orType: 1,
    sort: 2,
    code: "sniper_war",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "Sniper War"
      },
      {
        lang: "ZH",
        values: "狙击战"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/4224efb60d9e40429f2da32d721c8046.png",
    tags: [
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "modern_warfare",
        name: [
          {
            lang: "zh",
            values: "现代战争"
          },
          {
            lang: "en",
            values: "Modern Warfare"
          },
          {
            lang: "ja",
            values: "モダン・ウォーフェア"
          }
        ]
      },
      {
        code: "level-up",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Level-Up"
          },
          {
            lang: "ja",
            values: "レベルアップ"
          }
        ]
      },
      {
        code: "pve",
        name: [
          {
            lang: "zh",
            values: "PVE"
          },
          {
            lang: "en",
            values: "PVE"
          },
          {
            lang: "en",
            values: "PVE"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/d186d59453744fc2a15259899457ba6c/index.html"
  },
  {
    gameId: 180,
    orType: 1,
    sort: 2,
    code: "boxerio",
    type: 0,
    name: [
      {
        lang: "EN",
        values: "BoxerIo"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/857d599712a8438db09a9fc3b3359366.jpg",
    tags: [
      {
        code: "action",
        name: [
          {
            lang: "zh",
            values: "动作"
          },
          {
            lang: "en",
            values: "Action"
          },
          {
            lang: "ja",
            values: "アクション"
          }
        ]
      },
      {
        code: "magic",
        name: [
          {
            lang: "zh",
            values: "魔幻"
          },
          {
            lang: "en",
            values: "Magic"
          },
          {
            lang: "ja",
            values: "マジック"
          }
        ]
      },
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "fighting",
        name: [
          {
            lang: "zh",
            values: "格斗"
          },
          {
            lang: "en",
            values: "Fighting"
          },
          {
            lang: "ja",
            values: "格闘"
          }
        ]
      },
      {
        code: "io",
        name: [
          {
            lang: "zh",
            values: "对抗"
          },
          {
            lang: "en",
            values: "IO"
          },
          {
            lang: "ja",
            values: "対戦"
          }
        ]
      },
      {
        code: "collect",
        name: [
          {
            lang: "zh",
            values: "收集"
          },
          {
            lang: "en",
            values: "Collect"
          },
          {
            lang: "ja",
            values: "コレクション"
          }
        ]
      },
      {
        code: "upgrade",
        name: [
          {
            lang: "zh",
            values: "升级"
          },
          {
            lang: "en",
            values: "Upgrade"
          },
          {
            lang: "ja",
            values: "アップグレード"
          }
        ]
      },
      {
        code: "merge",
        name: [
          {
            lang: "zh",
            values: "合成"
          },
          {
            lang: "en",
            values: "Merge"
          },
          {
            lang: "ja",
            values: "合成"
          }
        ]
      },
      {
        code: "new",
        name: [
          {
            lang: "zh",
            values: "新品尝鲜"
          },
          {
            lang: "en",
            values: "New"
          },
          {
            lang: "ja",
            values: "新作"
          }
        ]
      }
    ],
    playUrl:
      "https://cdn.just4fun.sg/games/ea4f27c34f314cb58c079650a6e149f7/index.html"
  },
  {
    gameId: 135,
    orType: 1,
    sort: 20,
    code: "kingkong",
    type: 1,
    name: [
      {
        lang: "EN",
        values: "kingkong"
      },
      {
        lang: "ZH",
        values: "炸弹金刚"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/5fc6ebc90ce74291afd3a789bfcc04b7.jpg",
    tags: [
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "parkour",
        name: [
          {
            lang: "zh",
            values: "跑酷"
          },
          {
            lang: "en",
            values: "Parkour"
          },
          {
            lang: "ja",
            values: "パルクール"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      }
    ],
    playUrl: "https://tga.just4fun.sg/games/pk/kingkong/?egretGid=1"
  },
  {
    gameId: 136,
    orType: 1,
    sort: 20,
    code: "christmas",
    type: 1,
    name: [
      {
        lang: "EN",
        values: "christmas"
      },
      {
        lang: "ZH",
        values: "打雪仗"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/687a9687508748d9ae317c1c15a5ac0f.jpg",
    tags: [
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "battle",
        name: [
          {
            lang: "zh",
            values: "对战"
          },
          {
            lang: "en",
            values: "Battle"
          }
        ]
      }
    ],
    playUrl: "https://tga.just4fun.sg/games/pk/christmas/?egretGid=2"
  },
  {
    gameId: 138,
    orType: 1,
    sort: 20,
    code: "rhythmking",
    type: 1,
    name: [
      {
        lang: "EN",
        values: "rhythmking"
      },
      {
        lang: "ZH",
        values: "节奏达人"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/40728feaaca44197a8244680a70f174f.jpg",
    tags: [
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "music",
        name: [
          {
            lang: "zh",
            values: "音乐"
          },
          {
            lang: "en",
            values: "Music"
          }
        ]
      },
      {
        code: "rhythm",
        name: [
          {
            lang: "zh",
            values: "节奏"
          },
          {
            lang: "en",
            values: "Rhythm"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      }
    ],
    playUrl: "https://tga.just4fun.sg/games/pk/rhythmking/?egretGid=7"
  },
  {
    gameId: 139,
    orType: 1,
    sort: 20,
    code: "longjump",
    type: 1,
    name: [
      {
        lang: "EN",
        values: "longJump"
      },
      {
        lang: "ZH",
        values: "跳一跳"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/f20b4ef7abbe4e6395fed3e553cabd63.jpg",
    tags: [
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "cute",
        name: [
          {
            lang: "zh",
            values: "可爱"
          },
          {
            lang: "en",
            values: "Cute"
          },
          {
            lang: "ja",
            values: "かわいい系"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      },
      {
        code: "rhythm",
        name: [
          {
            lang: "zh",
            values: "节奏"
          },
          {
            lang: "en",
            values: "Rhythm"
          }
        ]
      }
    ],
    playUrl: "https://tga.just4fun.sg/games/pk/longJump/?egretGid=11"
  },
  {
    gameId: 140,
    orType: 1,
    sort: 20,
    code: "pigrun",
    type: 1,
    name: [
      {
        lang: "EN",
        values: "pigrun"
      },
      {
        lang: "ZH",
        values: "小猪快跑"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/8e1c095b6cf6482a83ac36c369bd41cc.jpg",
    tags: [
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "racing",
        name: [
          {
            lang: "zh",
            values: "竞速"
          },
          {
            lang: "en",
            values: "Racing"
          },
          {
            lang: "ja",
            values: "レース"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      }
    ],
    playUrl: "https://tga.just4fun.sg/games/pk/pigrun/?egretGid=4"
  },
  {
    gameId: 141,
    orType: 1,
    sort: 20,
    code: "shooting",
    type: 1,
    name: [
      {
        lang: "EN",
        values: "shooting"
      },
      {
        lang: "ZH",
        values: "炮弹射击"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/b6199cae76824e129a18e9c1013a5664.jpg",
    tags: [
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      },
      {
        code: "battle",
        name: [
          {
            lang: "zh",
            values: "对战"
          },
          {
            lang: "en",
            values: "Battle"
          }
        ]
      }
    ],
    playUrl: "https://tga.just4fun.sg/games/pk/shooting/?egretGid=3"
  },
  {
    gameId: 142,
    orType: 1,
    sort: 20,
    code: "leonardfrog",
    type: 1,
    name: [
      {
        lang: "EN",
        values: "leonardfrog"
      },
      {
        lang: "ZH",
        values: "青蛙过河"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/600cb67d9ad14e63b9aa90c7bf78fa0a.jpg",
    tags: [
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "casual",
        name: [
          {
            lang: "zh",
            values: "休闲"
          },
          {
            lang: "en",
            values: "Casual"
          },
          {
            lang: "ja",
            values: "カジュアル"
          }
        ]
      },
      {
        code: "obstacle",
        name: [
          {
            lang: "zh",
            values: "障碍"
          },
          {
            lang: "en",
            values: "Obstacle"
          },
          {
            lang: "ja",
            values: "障害物"
          }
        ]
      }
    ],
    playUrl: "https://tga.just4fun.sg/games/pk/leonardfrog/?egretGid=5"
  },
  {
    gameId: 143,
    orType: 1,
    sort: 20,
    code: "fiveinarow",
    type: 1,
    name: [
      {
        lang: "EN",
        values: "fiveinarow"
      },
      {
        lang: "ZH",
        values: "五子棋"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/c0b9a621d4584ce599ac65abb3d255fd.jpg",
    tags: [
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "strategy",
        name: [
          {
            lang: "zh",
            values: "策略"
          },
          {
            lang: "en",
            values: "Strategy"
          },
          {
            lang: "ja",
            values: "ストラテジー"
          }
        ]
      },
      {
        code: "brain",
        name: [
          {
            lang: "zh",
            values: "脑力"
          },
          {
            lang: "en",
            values: "Brain"
          },
          {
            lang: "ja",
            values: "思考"
          }
        ]
      },
      {
        code: "board",
        name: [
          {
            lang: "zh",
            values: "棋牌"
          },
          {
            lang: "en",
            values: "Board"
          },
          {
            lang: "ja",
            values: "ボード"
          }
        ]
      }
    ],
    playUrl: "https://tga.just4fun.sg/games/pk/fiveinarow/?egretGid=12"
  },
  {
    gameId: 144,
    orType: 1,
    sort: 20,
    code: "bang",
    type: 1,
    name: [
      {
        lang: "EN",
        values: "bang"
      },
      {
        lang: "ZH",
        values: "牛仔对决"
      }
    ],
    icon:
      "https://cdn.just4fun.sg/games/tgaupload/4c56331121be4d69a94a90f00158e4ec.jpg",
    tags: [
      {
        code: "pvp",
        name: [
          {
            lang: "zh",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          },
          {
            lang: "en",
            values: "PVP"
          }
        ]
      },
      {
        code: "skill",
        name: [
          {
            lang: "zh",
            values: "技巧"
          },
          {
            lang: "en",
            values: "Skill"
          },
          {
            lang: "ja",
            values: "スキル"
          }
        ]
      },
      {
        code: "battle",
        name: [
          {
            lang: "zh",
            values: "对战"
          },
          {
            lang: "en",
            values: "Battle"
          }
        ]
      },
      {
        code: "cartoon",
        name: [
          {
            lang: "zh",
            values: "卡通"
          },
          {
            lang: "en",
            values: "Cartoon"
          },
          {
            lang: "ja",
            values: "漫画"
          }
        ]
      },
      {
        code: "shooting",
        name: [
          {
            lang: "zh",
            values: "射击"
          },
          {
            lang: "en",
            values: "Shooting"
          },
          {
            lang: "ja",
            values: "シューティング"
          }
        ]
      }
    ],
    playUrl: "https://tga.just4fun.sg/games/pk/bang/?egretGid=10"
  }
];

module.exports = {
  allGame
};



// WEBPACK FOOTER //
// ./src/config/allGame.js